/**
 * Renders a prominent banner when the app is running in the production environment.
 *
 * Controlled via the Vite env var:
 *   - VITE_APP_ENV=production → banner is visible
 *   - any other value / undefined → banner is hidden
 */
export default function ProductionBanner() {
  const isProduction = import.meta.env.VITE_APP_ENV === 'production';

  if (!isProduction) return null;

  return (
    <div
      style={{
        backgroundColor: '#0d6efd',
        color: '#ffffff',
        padding: '0.5rem 1rem',
        textAlign: 'center',
        fontWeight: 600,
        letterSpacing: '0.03em',
        fontSize: '0.9rem',
        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
        zIndex: 1050,
      }}
    >
      DEMO - This application is currently in development.
    </div>
  );
}
